import { useEffect, useState } from 'react';

/**
 * Dải "AGADS vừa cập nhật bản mới — Tải lại".
 *
 * Lỗi thật 19/10/2026 trên bản thử: BOSS mở tab TRƯỚC lúc triển khai, không tải lại — trình duyệt vẫn
 * chạy giao diện cũ (file JS cũ đã nạp), nói chuyện với máy chủ mới: nút "Đồng bộ ngay" không đổi trạng
 * thái, thông báo nổi trống chữ. Trang chính (`/`) đặt no-cache nên chỉ cần TẢI LẠI là có bản mới —
 * dải này nói cho người dùng biết lúc nào cần tải lại.
 *
 * Cách biết có bản mới: file script chính đang chạy (`/assets/index-<mã>.js`, mã đổi theo mỗi lần build)
 * khác file mà trang chính vừa phát. Kiểm mỗi phút và mỗi khi quay lại tab. Không tự tải lại — người
 * dùng có thể đang gõ dở. Chạy dev (vite, không có /assets/index-) thì không làm gì.
 */
const MAU = /\/assets\/index-[^"'\s]+\.js/;

function scriptDangChay(): string | null {
  for (const s of Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'))) {
    const m = MAU.exec(s.src);
    if (m) return m[0];
  }
  return null;
}

export function DaiBanMoi() {
  const [coBanMoi, datCoBanMoi] = useState(false);

  useEffect(() => {
    const dangChay = scriptDangChay();
    if (!dangChay) return;
    let con = true;
    const kiem = () => {
      if (document.visibilityState !== 'visible') return;
      fetch('/', { cache: 'no-store' })
        .then((r) => r.text())
        .then((html) => {
          const moi = MAU.exec(html)?.[0];
          if (con && moi && moi !== dangChay) datCoBanMoi(true);
        })
        // Mất mạng / máy chủ đang khởi động lại: im lặng, lần kiểm sau thử tiếp.
        .catch(() => {});
    };
    const hen = window.setInterval(kiem, 60_000);
    document.addEventListener('visibilitychange', kiem);
    return () => {
      con = false;
      window.clearInterval(hen);
      document.removeEventListener('visibilitychange', kiem);
    };
  }, []);

  if (!coBanMoi) return null;
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '10px 14px',
        marginBottom: 14,
        borderRadius: 'var(--agads-bo-goc)',
        background: 'var(--agads-vang-nen)',
        border: '1px solid var(--agads-vang-vien)',
        color: 'var(--agads-vang-chu-dam)',
        fontSize: 13.5,
      }}
    >
      <span style={{ flex: 1, minWidth: 200 }}>
        AGADS vừa cập nhật bản mới. Tải lại trang để dùng bản mới — trang đang mở là bản cũ, có nút có thể không chạy đúng.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '7px 14px',
          borderRadius: 'var(--agads-bo-goc-tron)',
          border: '1px solid var(--agads-vang-vien)',
          background: 'var(--agads-nen-trang)',
          color: 'inherit',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Tải lại
      </button>
    </div>
  );
}
